export const SET_MENU = "/SET_MENU";
export const MENU_TOGGLE = "/MENU_TOGGLE";
export const MENU_OPEN = "/MENU_OPEN";
export const SET_FONT_FAMILY = "/SET_FONT_FAMILY";
export const SET_BORDER_RADIUS = "/SET_BORDER_RADIUS";
export const NAVIGATE = "/NAVIGATE";
export const TOKEN = "/TOKEN";
export const SNACKBAR_STATUS = "/SNACKBAR_STATUS";
export const LOGOUT = "/LOGOUT";
export const JSON_OBJECT = "/JSON_OBJECT";
export const END_POINT = "/END_POINT";
export const EDITOR_TITLE = "/EDITOR_TITLE";
export const DOWNLOAD_TITLE = "/DOWNLOAD_TITLE";
export const PROFILE = "/PROFILE";
export const IS_LOGGIN = "/IS_LOGGIN";
export const RESET = "/RESET";
export const TOKEN_EXPIRE = "/TOKEN_EXPIRE";
export const SEO_DATA = "SEO_DATA";
export const SEO_SEARCH = "SEO_SEARCH";
export const LOGIN_STATUS = "LOGIN_STATUS";
export const SEO_SEARCH_EMAIL = "SEO_SEARCH_EMAIL";




